//? Library Imports ------------------------------------------------------------>
import { useSelector } from "react-redux";
import { useState } from "react";
import { Space, Modal, Form, Col, Typography, Input, Radio, Row } from "antd";

//? Modules -------------------------------------------------------------------->
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";

//? Assets --------------------------------------------------------------------->
import { BsTrash } from "react-icons/bs";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

const SaveAddressModel = ({
  userAgent,
  ShowModal,
  saveAddress,
  setShowModal,
  setSelectedTag,
  setTagsList,
}) => {
  //? Hooks ---------------------------------------------------------------------->
  const [AddTag] = Form.useForm();
  const [tagValue, setTagValue] = useState("");
  const [tagAddingCheck, setTagAddingCheck] = useState(false);
  const { isMobile, isTablet, isDesktop } = userAgent;

  //? Redux States --------------------------------------------------------------->
  const comverse_customer_tags = useSelector(
    (state) => state?.accountSlice?.comverse_customer_tags
  );

  //? Functions ------------------------------------------------------------------>
  const addNewTag = (data) => {
    // const updatedTags = comverse_customer_tags;

    // updatedTags.push(data?.tag);
    // setAddressTagList(updatedTags);
    setSelectedTag(data?.tag);
    setShowModal(!ShowModal);

    saveAddress();
  };

  const tagAppendFunction = () => {
    if (tagValue !== "" && !tagAddingCheck) {
      setTagsList((prevItems) => [...prevItems, tagValue]);
      setTagAddingCheck(true);
    }
    if (tagValue !== "" && tagAddingCheck) {
      setTagsList((prevItems) => {
        // Pop the last element from the array
        const updatedItems = [...prevItems];
        updatedItems.pop();
        // Append the new tagValue
        return [...updatedItems, tagValue];
      });
    }
  };

  return (
    <Col>
      <Modal
        centered
        title="Add Tag"
        // className="SaveAddressModel"
        wrapClassName="SaveAddressModel"
        open={ShowModal}
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
        footer={
          <DynamicButton
            name="Save"
            className="primary_btn"
            function={() => {
              AddTag.submit();
              tagAppendFunction();
            }}
            style={{
              background: "#ff0d50",
              color: "#ffffff",
              width: "200px",
              margin: "auto",
            }}
          />
        }
      >
        <Col span={24}>
          <Row gutter={[15]}>
            <Col span={24} className="padding0">
              <Space className="width100 flexBetween">
                <Text className={!isDesktop ? "font12Bold" : "font14Bold"}>
                  Previous Tags
                </Text>
                <BsTrash size={16} />
              </Space>

              <Radio.Group
                // defaultValue="a"
                // onChange={onChange}
                className="addressTags marginTop10"
                style={{ display: "flex", gap: "10px" }}
              >
                {comverse_customer_tags?.map((tag, index) => {
                  return (
                    <Radio.Button
                      value={tag}
                      key={index}
                      className={
                        !isDesktop
                          ? "font12 tag borderRadius10"
                          : "tag borderRadius10"
                      }
                    >
                      {tag}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Col>

            <Col span={24} className="marginTop25 padding0">
              <Space direction="vertical" className="width100">
                <Text className={!isDesktop ? "font12Bold" : "font14Bold"}>
                  Add New Tag
                </Text>
                <Space
                  direction="vertical"
                  className="textEnd width100 marginTop10000"
                >
                  <Form
                    size="large"
                    form={AddTag}
                    autoComplete="on"
                    scrollToFirstError
                    onFinish={addNewTag}
                  >
                    <Form.Item
                      name="tag"
                      rules={[
                        {
                          max: 10,
                          required: true,
                          message: "Maximum 10 Character!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Tag Name"
                        onChange={(e) => {
                          setTagValue(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </Form>
                </Space>
              </Space>
            </Col>

            <Col span={24}>
              <Text className={!isDesktop ? "font12Bold" : "font14Bold"}>
                * 5 Max Tag Allowed
              </Text>
            </Col>
          </Row>
        </Col>
      </Modal>
    </Col>
  );
};
export default SaveAddressModel;
